import Notification from '@/resources/models/notification/Notification'
import {
  NotificationTypeEnum,
  NotificationCategoryEnum
} from '@/constants/notification.constants'
import { RiskLevelEnum } from '@/constants/risk-level.constants'

export default class TrailNotification extends Notification {
  constructor (uuid = null, attributes = {}, options = {}) {
    super(uuid, attributes, options)
    this.type = NotificationTypeEnum.TRAIL
    if (!_.isEmpty(this.details.eventCategory)) {
      this.setRiskLevel(this.details.eventCategory)
    }
  }

  setRiskLevel (eventCategory) {
    switch (eventCategory) {
      case NotificationCategoryEnum.LOW_MED:
        this.details.oldRiskLevel = RiskLevelEnum.LOW
        this.details.riskLevel = RiskLevelEnum.MEDIUM
        break
      case NotificationCategoryEnum.LOW_HIGH:
        this.details.oldRiskLevel = RiskLevelEnum.LOW
        this.details.riskLevel = RiskLevelEnum.HIGH
        break
      default:
        this.details.oldRiskLevel = RiskLevelEnum.MEDIUM
        this.details.riskLevel = RiskLevelEnum.HIGH
        break
    }
  }
}



// WEBPACK FOOTER //
// ./src/resources/models/notification/TrailNotification.js